import { makeCustomTheme } from './customTheme.js';

var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
/**
 * Factory function for creating a LightningChart JS Theme with a flat style based on very minimal configuration options.
 *
 * No-code interface for this factory can be found at https://arction.github.io/lcjs-themes/
 *
 * Pre-built versions generated using this factory can be found in this library:
 *
 * - `flatThemeDark` https://github.com/Arction/lcjs-themes/blob/main/src/flatThemeDark.ts
 * - `flatThemeLight` https://github.com/Arction/lcjs-themes/blob/main/src/flatThemeLight.ts
 *
 * @param   options - Configuration options for the created theme.
 * @returns LightningChart JS `Theme` object.
 * @deprecated  Deprecated in v3.2 over `makeCustomTheme`
 */
var makeFlatTheme = function (options) {
  return makeCustomTheme(__assign(__assign({}, options), {
    gradients: false,
    effects: false
  }));
};

export { makeFlatTheme };
